module.exports = __webpack_public_path__ + "img/lady4.2c5adf6f.png";